module.exports = __webpack_public_path__ + "static/media/qubit-label.a41e44fb.svg";